<template>
  <main class="fill-height-project">
    <section
      id="project-details"
      class="section-project-details"
    >
      <h2 class="big-heading-2">Case Study: {{ projectData[projectId].caseStudy.name || 'Project Name' }}</h2>
      <p>
        {{ projectData[projectId].caseStudy.details }}
      </p>

      <div class="my-row">
        <div class="col-lg-8 padding-top-20">
          <img
            class="img project-full-image"
            :src="`/images/projects/${projectId}/${projectId}.png`"
            :alt="projectId"
          />
        </div>
        <div class="col-lg-4 padding-15">
          <h5 class="project-name">{{ projectData[projectId].overview.name }}</h5>
          <h5 class="project-stats">
            <font-awesome-icon icon="industry" />
            &nbsp; <span>Industry</span>: {{ projectData[projectId].overview.industry }}
          </h5>
          <h5 class="project-stats">
            <font-awesome-icon icon="users" />
            &nbsp; <span>Size</span>: {{ projectData[projectId].overview.size }}
          </h5>
          <h5 class="project-stats">
            <font-awesome-icon icon="globe" />
            &nbsp; <span>Website</span>:
            <a
              :href="projectData[projectId].overview.website"
              target="_blank"
              rel="noopener noreferrer"
              title="Open website link"
            >
              {{ projectData[projectId].overview.website }}
            </a>
          </h5>
          <p :class="{'blur-content' : projectData[projectId].blurContent, }">
            {{ projectData[projectId].overview.shortDescription }}
          </p>
        </div>
      </div>

      <div class="my-row">
        <div class="big-heading-3">Project Overview</div>
        <p
          :class="{'blur-content' : projectData[projectId].blurContent, }"
        >
          {{ projectData[projectId].overview.details }}
        </p>
        <template v-if="projectData[projectId].overview.features">
          <p>Some of the key features include:</p>
          <ul class="project--features">
            <li
              v-for="f in projectData[projectId].overview.features"
              :key="f"
            >
              <font-awesome-icon icon="check" /> &nbsp; {{ f }}
            </li>
          </ul>
        </template>
      </div>

      <div class="my-row">
        <div class="big-heading-3">{{ projectData[projectId].challenge.label }}</div>
        <p
          v-for="(ch, index) in projectData[projectId].challenge.details"
          :key="'challange-'+index"
          :class="{'blur-content' : projectData[projectId].blurContent, }"
        >
          {{ ch }}
        </p>
      </div>

      <div class="my-row">
        <div class="big-heading-3">{{ projectData[projectId].solution.label }}</div>
        <p :class="{'blur-content' : projectData[projectId].blurContent, }">
          {{ projectData[projectId].solution.details }}
        </p>
      </div>

      <div class="my-row">
        <project-gallery :project="projectId"></project-gallery>
      </div>

      <div class="my-row">
        <div class="big-heading-3 col-lg-12">The Results</div>
        <div class="project-summery-container">
          <div
            v-for="m in projectData[projectId].result.metrics"
            :key="m.label"
            class="col-xs-12 col-lg-3 col-md-6"
          >
            <strong>{{ m.label }}</strong>
            <span>
              {{ m.text }}
              <font-awesome-icon
                v-if="m.pointer === 'up'"
                icon="arrow-circle-up" />
              <font-awesome-icon
                v-if="m.pointer === 'down'"
                icon="arrow-circle-down" />
            </span>
            <p
              class="lead"
              :class="{'blur-content' : projectData[projectId].blurContent, }">
              {{ m.details }}
            </p>
          </div>
        </div>
        <p :class="{'blur-content' : projectData[projectId].blurContent, }">
          {{ projectData[projectId].result.details }}
        </p>
      </div>
    </section>
  </main>
</template>

<script>
import ProjectGallery from '../components/ProjectGallery'

export default {
  name: 'ProjectDetails',
  components: {
    ProjectGallery
  },
  data () {
    return {
      projectId: this.$route.params.pid.toLowerCase(),
      projectData: {
        levi: {
          blurContent: false,
          caseStudy: {
            name: 'Levi\'s Ecommerce',
            details: 'Levi Strauss & Co. is an American clothing company known worldwide for its Levi\'s brand of denim jeans. It was founded in May 1853 when German immigrant Levi Strauss moved from Buttenheim, Bavaria, to San Francisco, California, to open a west coast branch of his brothers\' New York dry goods business.'
          },
          overview: {
            name: 'LEVI\'S & STRAUSS ECOMMERCE',
            industry: 'Retail',
            size: '50+',
            website: 'https://levi.com/US/en_US',
            shortDescription: 'Levi\'s the retail client having omnichannel business in US, Canada, and various UK regions. The main requirement was to create a modern web app that can replace their existing website and provide users a much faster, better, and smoother user experience with a rich interface',
            details: 'Our main goal was to replace the old front-end layer with a modern, faster, and beautiful UI that can give users a better experience. We created two main layers, the webhooks layer, and the front end layer. WebHook layer containing Node JS, Express, and GraphQL(Appolo Server). The main purpose was to merge all the microservices and pass them to the front-end layer as per the need. The front end layer consists of Vue js, Apollo Client, SCSS to create a modern and rich UI.'
          },
          challenge: {
            label: 'The Challenge',
            details: [
              'We faced two major challenges. The first one was the backend server was already written in Hybris and we can\'t touch or modify it to our need. So we created a middle layer called the webhooks layer to merge all the microservices and rearrange them as per our need. There were many third-party vendors as well like authentication providers, payment providers, delivery partners, Loyalty providers, and many more. Our webhooks can directly talk to them and reduce the burden to our main backend layer. This hugely optimized server performance and reduced cost.',
              'The second challenge was to provide a central solution for authentication and authorization. As the business is omnichannel, so we needed to take care of authorizations for mobile apps, stock managers, in-house applications, and many more. To solve that we moved to okta to provide a two-way authentication system for users and vendors. On top of that, we implemented password-less authentication to make the process seamless and secure.'
            ]
          },
          solution: {
            label: 'The Approach & Solution',
            details: 'We resolved most of our problems with our webhooks layer. Our webhooks layer directly talks to our main backend, authentication provider, and third-party vendors. This optimized our overall performance and cost. On top of that, we have used Redis to cache a few repetitive calls and most of our popular product details. That leads to great performance improvement again. Users can surf through the website with great speed. We also integrated Progressing web app features. With that, we provided offline support for certain pages. This again improved performance and overall user experience.'
          },
          result: {
            metrics: [
              {
                label: 'Efficiency',
                text: '30%',
                pointer: 'up',
                details: 'We improved efficiency to a great extent'
              },
              {
                label: 'Customer Satisfaction',
                text: '14%',
                pointer: 'up',
                details: 'This data is as per our internal survey'
              },
              {
                label: 'Sales Generated',
                text: '7-10%',
                pointer: 'up',
                details: 'We improved our overall sales in rush hours'
              },
              {
                label: 'Overall Cost',
                text: '20%',
                pointer: 'down',
                details: 'Client and server caches reduced the overall cost'
              }
            ],
            details: 'The full project took around 1.3 years to reach a production-ready state. As we could deliver the entire solution with very stable conditions, the client satisfaction was really high. Along with the main requirements we took care of the SEO requirements. We made the entire website fully accessible to match the global standard. Overall the project was a huge success for us.'
          }
        },
        gintaav3: {
          blurContent: false,
          caseStudy: {
            name: 'Gintaa',
            details: 'With years of research and strict deadlines, our computer geniuses are ready with a unique concept where you can “give and take anything”. It is the one-stop destination for every dreamer, who wants to establish their business or merely get amazing products/services for incredible offers.'
          },
          overview: {
            name: 'Gintaa',
            industry: 'E Commerce',
            size: '70+',
            website: 'https://gintaa.com/',
            shortDescription: 'The main client is Asconsoft India Ltd, a company based in Kolkata, India. Gintaa is a product where users can buy, sell or bid on an existing item with other users. Local businesses can also register here to sell their products directly to the customers.',
            details: 'The goal was to create the one-stop destination for every dreamer, who wants to establish their business or merely get amazing products/services for incredible offers. The name is gintaa, which is here to identify your real-life problems to devise the right solutions without any fail.',
            features: [
              'A barter platform for both products & services',
              'Hassle-free doorstep assured delivery available',
              'A platform to expand business for free',
              'Zero commission, absolute growth',
              'Password-less login with a magic link',
              'Secured gintaa junction for personal transactions.'
            ]
          },
          challenge: {
            label: 'The Challenge',
            details: [
              'The main challenge of the project was to combine B2C, C2B, and C2C requirements and deliver a unique solution that can seamlessly provide all the necessary features to the businesses and end-users. Another challenge was to provide a common one for all authorization systems.'
            ]
          },
          solution: {
            label: 'The Approach & Solution',
            details: 'Our approach to the problems was granular. We wanted to tackle one problem at a time. First, we focused on the C2C segment and started implementing the requirements. Once it was ready we moved to another segment and so on. We created the front-end layer with Angular. With the help of Angular universal, we have implemented an SEO-friendly platform. We integrated NGRX for our internal state management, firebase as an authentication provider, fire-store to boost our chat system, and many more.'
          },
          result: {
            metrics: [
              {
                label: 'Efficiency',
                text: '10%',
                pointer: 'up',
                details: 'With the help of SSR efficiency improved'
              },
              {
                label: 'Customer Satisfaction',
                text: '15%',
                pointer: 'up',
                details: 'This is from our internal customer feedback'
              },
              {
                label: 'Site Speed Increased',
                text: '12%',
                pointer: 'up',
                details: 'heavily increased the speed index'
              },
              {
                label: 'Overall Cost',
                text: '20%',
                pointer: 'down',
                details: 'Overall cost went down with cloud functions'
              }
            ],
            details: 'The full project took around 1.5 years to reach a production-ready state. As we could deliver the entire solution with very stable conditions, the client satisfaction was high. Along with the main requirements we took care of the SEO requirements. We made the entire website fully accessible to match the global standard. Overall the project was a huge success for us.'
          }
        },
        lilly: {
          blurContent: true,
          caseStudy: {
            name: 'Lilly India',
            details: 'Since its inception in India in 1993, Eli Lilly and Company (India) Pvt. Ltd. has been committed to developing and marketing pharmaceutical products to treat diabetes, gastric cancer, lung cancer, osteoporosis, rheumatoid arthritis, men\'s health and growth-hormone deficiency. Lilly India affiliate also comprises operations in neighboring countries of Nepal, Bangladesh and Sri Lanka.'
          },
          overview: {
            name: 'Lilly',
            industry: 'Tech',
            size: '100+',
            website: 'https://lilly.com/',
            shortDescription: 'Short description of the client and project requirements. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.',
            details: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quod totam dicta reiciendis ipsa voluptates, omnis cumque officia itaque deleniti et aut tempora neque architecto eveniet delectus, harum enim doloribus eos. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut, a deserunt ipsam sunt aliquam qui enim quasi eum ex nulla dolore rerum explicabo iusto iste error sapiente! Reiciendis, aliquid a.'
          },
          challenge: {
            label: 'The Challenge',
            details: ['Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quod totam dicta reiciendis ipsa voluptates, omnis cumque officia itaque deleniti et aut tempora neque architecto eveniet delectus, harum enim doloribus eos. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut, a deserunt ipsam sunt aliquam qui enim quasi eum ex nulla dolore rerum explicabo iusto iste error sapiente! Reiciendis, aliquid a.']
          },
          solution: {
            label: 'The Approach & Solution',
            details: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quod totam dicta reiciendis ipsa voluptates, omnis cumque officia itaque deleniti et aut tempora neque architecto eveniet delectus, harum enim doloribus eos. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut, a deserunt ipsam sunt aliquam qui enim quasi eum ex nulla dolore rerum explicabo iusto iste error sapiente! Reiciendis, aliquid a.'
          },
          result: {
            metrics: [
              {
                label: 'Efficiency',
                text: '8%',
                pointer: 'up',
                details: 'Metric description lorem ipsum dolor sit amet'
              },
              {
                label: 'Customer Satisfaction',
                text: '10%',
                pointer: 'up',
                details: 'Metric description lorem ipsum dolor sit amet'
              },
              {
                label: 'Sales Generated',
                text: '--',
                pointer: null,
                details: 'Metric description lorem ipsum dolor sit amet'
              },
              {
                label: 'Overall Cost',
                text: '5%',
                pointer: 'down',
                details: 'Metric description lorem ipsum dolor sit amet'
              }
            ],
            details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero, pariatur dicta repellat, aliquam magni voluptates non ipsam obcaecati et sed autem. Nesciunt deserunt dolores sit ad soluta tempore explicabo magni. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quasi accusamus minus reprehenderit optio ab? Nostrum, repudiandae. Reiciendis, modi dolorem soluta sapiente reprehenderit hic id, ipsam debitis illum, pariatur rem molestiae.'
          }
        },
        bitclude: {
          blurContent: true,
          caseStudy: {
            name: 'Bitclude',
            details: 'BitClude is a Bitcoin exchange available 24/7, to all registered users. It only takes 3 minutes to register and verify your identity with a simple ID, and with this simple procedure you will always be able to buy Bitcoins!'
          },
          overview: {
            name: 'Bitclude',
            industry: 'Tech',
            size: '100+',
            website: 'https://bitclude.com/',
            shortDescription: 'Short description of the client and project requirements. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.',
            details: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quod totam dicta reiciendis ipsa voluptates, omnis cumque officia itaque deleniti et aut tempora neque architecto eveniet delectus, harum enim doloribus eos. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut, a deserunt ipsam sunt aliquam qui enim quasi eum ex nulla dolore rerum explicabo iusto iste error sapiente! Reiciendis, aliquid a.'
          },
          challenge: {
            label: 'The Challenge',
            details: ['Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quod totam dicta reiciendis ipsa voluptates, omnis cumque officia itaque deleniti et aut tempora neque architecto eveniet delectus, harum enim doloribus eos. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut, a deserunt ipsam sunt aliquam qui enim quasi eum ex nulla dolore rerum explicabo iusto iste error sapiente! Reiciendis, aliquid a.']
          },
          solution: {
            label: 'The Approach & Solution',
            details: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quod totam dicta reiciendis ipsa voluptates, omnis cumque officia itaque deleniti et aut tempora neque architecto eveniet delectus, harum enim doloribus eos. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut, a deserunt ipsam sunt aliquam qui enim quasi eum ex nulla dolore rerum explicabo iusto iste error sapiente! Reiciendis, aliquid a.'
          },
          result: {
            metrics: [
              {
                label: 'Efficiency',
                text: '20%',
                pointer: 'up',
                details: 'Metric description lorem ipsum dolor sit amet'
              },
              {
                label: 'Customer Satisfaction',
                text: '14%',
                pointer: 'up',
                details: 'Metric description lorem ipsum dolor sit amet'
              },
              {
                label: 'Sales Generated',
                text: '$130K',
                pointer: null,
                details: 'Metric description lorem ipsum dolor sit amet'
              },
              {
                label: 'Overall Cost',
                text: '20%',
                pointer: 'down',
                details: 'Metric description lorem ipsum dolor sit amet'
              }
            ],
            details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero, pariatur dicta repellat, aliquam magni voluptates non ipsam obcaecati et sed autem. Nesciunt deserunt dolores sit ad soluta tempore explicabo magni. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quasi accusamus minus reprehenderit optio ab? Nostrum, repudiandae. Reiciendis, modi dolorem soluta sapiente reprehenderit hic id, ipsam debitis illum, pariatur rem molestiae.'
          }
        }
      }
    }
  },
  methods: {
    fetchProject () {}
  }
}
</script>

<style lang="scss" scoped>
@import url('../assets/scss/pages/_project.scss');

.section-project-details {
  padding: 0px;
}
h2 {
  color: $green;
  margin: 0px;
  font-size: clamp(26px, 5vw, 60px);
}

p {
  margin: 20px 0px 0px;
  max-width: 100vw;
}
.my-row {
  display: flex;
  flex-wrap: wrap;
  margin-top: 60px;

  .project--features {
    flex-basis: 100%;
    list-style: none;
    padding-left: 0;

    svg {
      color: $green;
      font-size: 10px;
    }
  }

  .col-lg-6 {
    -webkit-box-flex: 0;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-8 {
    -webkit-box-flex: 0;
    flex: 0 0 60%;
    max-width: 60%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    max-width: 100%;
  }
  .col-lg-4 {
    -webkit-box-flex: 0;
    flex: 0 0 40%;
    max-width: 40%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 25%;
    max-width: 25%;
  }
}
.project-name {
  color: $green;
  text-transform: uppercase;
  word-spacing: 1px;
  font-weight: bold;
}
.project-summery-container {
  display: flex;
  flex: 0 0 100%;
  max-width: 100%;
  padding: 20px 0px;
}
.project-summery-container > div {
  margin-bottom: 0;
  padding: 10px;
}

.project-summery-container strong {
  display: block;
  color: $green;
}
.project-summery-container span {
  font-weight: bold;
  font-size: 2rem;
  margin-bottom: .5rem;
  color: #fff;
}
.project-summery-container p {
  font-size: 1rem;
  color: #ccd6f6;
}

.project-summery-container > div:nth-child(odd) {
  background: #11bb92;

  strong {
    color: $navy;
  }
  p {
    color: $navy;
  }
}

.blur-content {
  color: transparent !important;
  text-shadow: 0 0 5px rgb(255, 254, 254);
}
</style>
